import { ActionIcon, BackgroundImage, Badge, Box, Button, Card, Center, Container, Divider, Flex, Grid, Group, Image, Loader, Modal, Stack, Text, Textarea, Title, useMantineTheme } from '@mantine/core';
import { Dropzone } from '@mantine/dropzone';
import { useForm } from '@mantine/form';
import { Files, Trash } from '@phosphor-icons/react';
import { useAgencyAPI } from 'api/useAgencyAPI';
import PageLoader from 'components/LoadingStates/PageLoader';
import { convertFileToPreview } from 'helpers/utility';
import { useUpload } from 'hooks/useUpload';
import React, { useCallback, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import ProfileLayoutTemplate from './AgentDashboard/components/ProfileLayoutTemplate';
import { useMediaQuery } from '@mantine/hooks';
import AgencyCard from './AgentDashboard/components/AgencyCard';
import DeveloperCard from './AgentDashboard/components/DeveloperCard';
import { useDeveloperAPI } from 'api/useDeveloperAPI';
import { useVendorAPI } from 'api/useVendorAPI';
import VendorCard from './AgentDashboard/components/VendorCard';

const VendorProfile = () => {
    const { slug } = useParams()
    const { useGetOneVendorBySlug } = useVendorAPI()
    const { data, isLoading, error } = useGetOneVendorBySlug(slug ?? "")
    const theme = useMantineTheme()
    const isMd = useMediaQuery(`(max-width: ${theme.breakpoints.md})`);

    const vendorData = useMemo(() => {
        if (!!data) {
            return data[0]
        }
        return {}
    }, [data])

    const layoutData = useMemo(() => {

        if (!!data && data.length > 0) {
            return data[0].profile
        }
        
        return {
            "text": {
                "title": "",
                "description": "",
                "textRow1": "",
                "textRow2": "",
                "textRow3": ""
            },
            "images": {
                "banner": {
                    "file": null
                },
                "imageRow1": {
                    "file": null
                },
                "imageRow2": {
                    "file": null
                },
                "imageRow3": {
                    "file": null
                },
            }
        }
    }, [data])

    if (!!isLoading) {
        <PageLoader title="Agency Profile" />
    }

    return (
        <Box pos="relative">
        <Container py={32}>
                <Stack>
                    {!!vendorData && (
                        <VendorCard
                            data={vendorData}
                        />
                    )}
                    <ProfileLayoutTemplate data={layoutData} />
                </Stack>
            </Container>
        </Box>
    );
};

export default VendorProfile;